import React from "react";
import {
  TextField,
  InputAdornment,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "../../assets/styles/common/table.css";

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "Search...",
  value,
  onChange,
  fullWidth = true,
}) => {
  return (
    <Box className="search-bar-container">
      <TextField
        fullWidth={fullWidth}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="search-bar-field"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="search-bar-icon" />
            </InputAdornment>
          ),
          className: "search-bar-input",
        }}
      />
    </Box>
  );
};

export default SearchBar;
